import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import assert from '@/sui/tools/assert'
import patient from '@/sui/data/sheets/edit/patient'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'
import clone from 'clone'

import {
  checkAge,
  checkDate,
  checkB2Gloves,
  checkDeviceInsertionSite,
  checkProbeTouchedWithGloves,
  checkBMI,
  checkP1Chlorex,
  checkNeedleWithdrawalManipType,
  checkEhpadService,
  checkIsolatedRinsingOfContinuousCatheter,
  checkGelAppliedWithoutSheath,
  checkVialOpenedSince,
  checkHeadFaceSterileField,
  checkGelUsed,
  checkRinsingSuccessivePushesCount
} from '@/sui/data/sheets/edit/notes/observa4'

import v2024 from '@/sui/data/sheets/edit/observa4/2024'
const result = clone(v2024)

//     UPDATE    p1type (list)          p1type>config>values: different sizes
result.fields.catheterType.p1.config.values = go.fields.p1Type

//     UPDATE    b1type (list)          b1type>config>values: different sizes
result.fields.catheterType.b1.config.values = go.fields.b1Type

// +++ ADD       b2otherCatheterType (text)
result.fields.otherCatheterType.b2 = tools.cfg.text(
  `b2${fields.otherCatheterType}`, result.fields.otherCatheterType.p1.config.title, {
    sel: tools.equals(result.fields.catheterType.b2.field, 6),
    srv: fields.otherCatheterType
  }
)

// +++ ADD       deviceUsage (list)
result.fields.deviceUsage = {
  b1b2: tools.cfg.list(
    fields.deviceUsage, `Utilisation du cathéter`, go.fields.deviceUsage, {
      sel: tools.oneTrue(
        tools.allTrue(
          result.select.b1,
          tools.inList(`b1${fields.catheterType}`, [7, 8, 9])
        ),
        result.select.b2
      )
    }
  )
}

// +++ ADD       b1manipType (list)
// +++ ADD       b2manipType (list)
// --- REMOVE    manipType (list)
result.fields.manipType = (function () {
  const reference = result.fields.manipType.b2
  const t = reference.config.title
  const f = fields.manipType

  return {
    b1: tools.cfg.list(
      `b1${f}`, t, go.fields.manipType, { sel: result.select.b1, srv: f }
    ),

    b2: tools.cfg.list(
      `b2${f}`, t, go.fields.b2ManipType, { sel: result.select.b2, srv: f }
    )
  }
})()

//     UPDATE    otherManipType (text)  otherManipType>selectList>0/0: different function names "(manipType === 6)" "oneTrue ((b1manipType === 6), (b2manipType === 6))}"
result.fields.otherManipType.b1b2 = tools.select(
  result.fields.otherManipType.b2,
  tools.oneTrue(
    tools.equals(result.fields.manipType.b1.field, 6),
    tools.equals(result.fields.manipType.b2.field, 6)
  )
)

// --- REMOVE    secondManipType (list)
delete result.fields.secondManipType

// --- REMOVE    secondOtherManipType (text)
delete result.fields.secondOtherManipType

// +++ ADD       isolatedRinsingReason (list)
result.fields.isolatedRinsingReason = {
  b1b2: tools.cfg.list(
    fields.isolatedRinsingReason, `Pourquoi le cathéter est-il rincé ?`,
    go.fields.isolatedRinsingReason, {
      sel: tools.allTrue(
        result.select.b1b2,
        tools.oneTrue(
          tools.equals(result.fields.manipType.b1.field, 5),
          tools.equals(result.fields.manipType.b2.field, 5)
        )
      )
    }
  )
}

// +++ ADD       isolatedRinsingReasonDetail (text)
result.fields.isolatedRinsingReasonDetail = {
  b1b2: tools.cfg.text(
    fields.isolatedRinsingReasonDetail, 'Préciser la raison du rinçage',
    { sel: tools.equals(result.fields.isolatedRinsingReason.b1b2.field, 3) }
  )
}

//     UPDATE    b2auditedCap (list)    b2auditedCap>selectList>0/0: different function names "allTrue ((obsManagment === 5), (unitTypeMatch /^NEO/))" "allTrue ((obsManagment === 5), oneTrue ((unitTypeMatch /^NEO/), (unitTypeMatch /^AD DIA/)))}"
result.fields.auditedCap.b2 = tools.select(
  result.fields.auditedCap.b2,
  tools.allTrue(result.select.b2, patient.select.isNeoOrAdDia)
)

//     UPDATE    withUltrasound (list)  withUltrasound>selectList>0/0: different function names "(obsManagment === 1)" "oneTrue ((obsManagment === 1), (obsManagment === 2))}"
result.fields.withUltrasound = {
  p1p2: tools.select(
    result.fields.withUltrasound.p1,
    result.select.p1p2
  )
}

result.rename(result.fields.usAuditedSearch, 'p1', 'p1p2')
result.rename(result.fields.searchGelUsed, 'p1', 'p1p2')
result.rename(result.fields.vialOpeningDateWritten, 'p1', 'p1p2')
result.rename(result.fields.vialOpenedSince, 'p1', 'p1p2')
result.rename(result.fields.searchUltrasoundSheath, 'p1', 'p1p2')
result.rename(result.fields.sheathRemoval, 'p1', 'p1p2')
result.rename(result.fields.ultrasoundWipingSearch, 'p1', 'p1p2')
result.rename(result.fields.insertionUltrasoundSheath, 'p1', 'p1p2')
result.rename(result.fields.probeCovered, 'p1', 'p1p2')
result.rename(result.fields.sheathJustBeforeInsertion, 'p1', 'p1p2')
result.rename(result.fields.insertionGelUsed, 'p1', 'p1p2')
result.rename(result.fields.gelApplied, 'p1', 'p1p2')
result.rename(result.fields.probeNeedleContact, 'p1', 'p1p2')
result.rename(result.fields.auditedTouchProbe, 'p1', 'p1p2')
result.rename(result.fields.probeTouchedWith, 'p1', 'p1p2')
result.rename(result.fields.probeTouchedWithDetail, 'p1', 'p1p2')
result.rename(result.fields.nakedEyeSheathInspection, 'p1', 'p1p2')
result.rename(result.fields.probeInspection, 'p1', 'p1p2')
result.rename(result.fields.tearedSheath, 'p1', 'p1p2')
result.rename(result.fields.dirtyProbe, 'p1', 'p1p2')
result.rename(result.fields.probeCleaned, 'p1', 'p1p2')
result.rename(result.fields.probeCleaningMethod, 'p1', 'p1p2')
result.rename(result.fields.probeCleaningMethodDetail, 'p1', 'p1p2')
result.rename(result.fields.probeCleaningProduct, 'p1', 'p1p2')

// --- REMOVE    r1soap (list)
// +++ ADD       p1p2p3p4r1soap (list)
result.fields.soap = {
  p1p2p3p4r1: tools.cfg.list(
    `p1p2p3p4r1${fields.soap}`, result.fields.soap.r1.config.title,
    go.fields.soap, {
      sel: tools.allTrue(
        result.select.p1p2p3p4r1,
        result.select.yes(result.fields.insertionSiteCleaned.p1p2p3p4r1.field)
      ),
      srv: fields.soap
    }
  )
}

// +++ ADD       p1p2p3p4r1soapOther (text)
result.fields.soapOther = {
  p1p2p3p4r1: tools.cfg.text(
    `p1p2p3p4r1${fields.soapOther}`, `Préciser le type de savon utilisé`, {
      sel: tools.allTrue(
        result.select.p1p2p3p4r1,
        tools.equals(result.fields.soap.p1p2p3p4r1.field, 3)
      ),
      srv: fields.soapOther
    }
  )
}

//     UPDATE    r1UseCompresses (list) r1UseCompresses>config>values: different sizes
result.fields.useCompresses.r1.config.values = go.fields.yesNo

//     UPDATE    r1UseCompresses (list) r1UseCompresses>selectList>0/0: different function names "allTrue ((obsManagment === 7), (r1AntisepticApplied === 1))" "allTrue ((obsManagment === 7), (r1AntisepticApplied === 1), (r1Antiseptic != null && r1Antiseptic !== 7))}"
result.fields.useCompresses.r1 = tools.select(
  result.fields.useCompresses.r1,
  tools.allTrue(
    result.select.r1,
    result.select.yes(result.fields.antiseptic.r1[0].field),
    tools.different(result.fields.antiseptic.r1[1].field, 7)
  )
)

//     UPDATE    p1p2p3p4UseCompresses (list)p1p2p3p4UseCompresses>config>values: different sizes
result.fields.useCompresses.p1p2p3p4.config.values = go.fields.yesNo

//     UPDATE    p1p2p3p4UseCompresses (list)p1p2p3p4UseCompresses>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 6)), (p1p2p3p4AntisepticApplied === 1))" "allTrue (allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3), (obsManagment === 6)), (p1p2p3p4AntisepticApplied === 1)), (p1p2p3p4Antiseptic != null && p1p2p3p4Antiseptic !== 7))}"
result.fields.useCompresses.p1p2p3p4 = tools.select(
  result.fields.useCompresses.p1p2p3p4,
  tools.allTrue(
    tools.allTrue(
      result.fields.antiseptic.p1p2p3p4[0].selectList._list[0],
      result.select.yes(result.fields.antiseptic.p1p2p3p4[0].field)
    ),
    tools.different(result.fields.antiseptic.p1p2p3p4[1].field, 7)
  )
)

// +++ ADD       p2glovesRemoval (list)
result.fields.glovesRemoval.p2 = tools.cfg.list(
  `p2${fields.glovesRemoval}`, `Retrait des gants après avoir touché l'échographe (ou d'une paire si double gantage)`,
  go.fields.yesNo, {
    sel: tools.allTrue(
      tools.equals(result.fields.probeTouchedWith.p1p2.field, 1),
      tools.allTrue(
        result.select.p2,
        result.select.yes(result.fields.gloves.p2p3.field)
      )
    ),
    srv: fields.glovesRemoval
  }
)

// +++ ADD       p1p2rinsingAfterCatheterInsertion (list)
// +++ ADD       p3rinsingAfterCatheterInsertion (list)
result.fields.rinsingAfterCatheterInsertion = {
  p1p2: tools.cfg.list(
    `p1p2${fields.rinsingAfterCatheterInsertion}`,
    `Le cathéter est rincé juste après l'insertion`,
    go.fields.yesNo, {
      sel: result.select.p1p2,
      srv: fields.rinsingAfterCatheterInsertion
    }
  ),

  p3: tools.cfg.list(
    `p3${fields.rinsingAfterCatheterInsertion}`,
    `L'aiguille est rincée juste après la ponction ?`,
    go.fields.yesNo, {
      sel: result.select.p3,
      srv: fields.rinsingAfterCatheterInsertion
    }
  )
}

// +++ ADD       rinsingBeforeManipulation (list)
result.fields.rinsingBeforeManipulation = {
  b1b2: tools.cfg.list(
    fields.rinsingBeforeManipulation,
    `La ligne est rincée juste <b>avant</b> la manipulation`,
    go.fields.yesNo, {
      sel: tools.oneTrue(
        tools.allTrue(
          result.select.b1,
          tools.inList(
            result.fields.manipType.b1.field, [1, 3, 4, 6]
          )
        ),

        tools.allTrue(
          result.select.b2,
          tools.inList(
            result.fields.manipType.b2.field, [1, 3, 4, 6, 7]
          )
        )
      )
    }
  )
}

// +++ ADD       rinsingAfterManipulation (list)
result.fields.rinsingAfterManipulation = {
  b1b2: tools.cfg.list(
    fields.rinsingAfterManipulation,
    `La ligne est rincée juste <b>après</b> la manipulation`,
    go.fields.yesNo, {
      sel: tools.oneTrue(
        tools.allTrue(
          result.select.b1,
          tools.inList(
            result.fields.manipType.b1.field, [2, 3, 4, 6]
          )
        ),

        tools.allTrue(
          result.select.b2,
          tools.inList(
            result.fields.manipType.b2.field, [2, 3, 4, 6]
          )
        )
      )
    }
  )
}

result.select.withRinsing = tools.oneTrue(
  result.select.yes(result.fields.rinsingAfterCatheterInsertion.p1p2.field),
  result.select.yes(result.fields.rinsingAfterCatheterInsertion.p3.field),
  result.select.yes(result.fields.rinsingBeforeManipulation.b1b2.field),
  result.select.yes(result.fields.rinsingAfterManipulation.b1b2.field),
  tools.equals(result.fields.manipType.b1.field, 5),
  tools.equals(result.fields.manipType.b2.field, 5)
)

// +++ ADD       p1insertionGlovesKeptForRinsing (list)
// +++ ADD       p3insertionGlovesKeptForRinsing (list)
result.fields.insertionGlovesKeptForRinsing = {
  p1: tools.cfg.list(
    `p1${fields.insertionGlovesKeptForRinsing}`,
    `Les gants utilisés lors de l'insertion sont gardés pour le rinçage`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        tools.allTrue(
          result.select.p1,
          result.select.yes(result.fields.gloves.p1.field)
        ),
        result.select.withRinsing
      ),
      srv: fields.insertionGlovesKeptForRinsing
    }
  ),
  p3: tools.cfg.list(
    `p3${fields.insertionGlovesKeptForRinsing}`,
    `Les gants utilisés lors de la ponction sont gardés pour le rinçage`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        tools.allTrue(
          result.select.p3,
          result.select.yes(result.fields.gloves.p2p3.field)
        ),
        result.select.withRinsing
      ),
      srv: fields.insertionGlovesKeptForRinsing
    }
  )
}

// +++ ADD       syringeCapacity (list)
result.fields.syringeCapacity = {
  p1p2p3b1b2: tools.cfg.list(
    fields.syringeCapacity, `Capacité de la seringue utilisée ?`,
    go.fields.syringeCapacity, {
      sel: tools.allTrue(
        result.select.p1p2p3b1b2, result.select.withRinsing
      )
    }
  )
}

// +++ ADD       syringeCapacityOther (numeric)
result.fields.syringeCapacityOther = {
  p1p2p3b1b2: tools.cfg.numeric(
    fields.syringeCapacityOther, `Préciser la capacité de la seringue en mL`, 2, {
      sel: tools.equals(result.fields.syringeCapacity.p1p2p3b1b2.field, 3),
      un: 'mL'
    }
  )
}

// +++ ADD       injectedRinsingSolution (list)
result.fields.injectedRinsingSolution = {
  p1p2p3b1b2: tools.cfg.list(
    fields.injectedRinsingSolution, `La solution injectée est`,
    go.fields.injectedRinsingSolution, {
      sel: tools.allTrue(result.select.p1p2p3b1b2, result.select.withRinsing)
    }
  )
}

// +++ ADD       injectedRinsingSolutionOther (text)
result.fields.injectedRinsingSolutionOther = {
  p1p2p3b1b2: tools.cfg.text(
    fields.injectedRinsingSolutionOther, `Préciser la solution injectée`, {
      sel: tools.equals(result.fields.injectedRinsingSolution.p1p2p3b1b2.field, 3)
    }
  )
}

// +++ ADD       readyPreFilledSyringe (list)
result.fields.readyPreFilledSyringe = {
  p1p2p3b1b2: tools.cfg.list(
    fields.readyPreFilledSyringe,
    `La seringue est pré-remplie prête à l'emploi`,
    go.fields.yesNo, {
      sel: tools.allTrue(result.select.p1p2p3b1b2, result.select.withRinsing)
    }
  )
}

// +++ ADD       singleDoseRinsingSolution (list)
result.fields.singleDoseRinsingSolution = {
  p1p2p3b1b2: tools.cfg.list(
    fields.singleDoseRinsingSolution,
    `L'ampoule/la poche de solution est stérile monodose`,
    go.fields.yesNo, {
      sel: result.select.no(result.fields.readyPreFilledSyringe.p1p2p3b1b2.field)
    }
  )
}

// +++ ADD       syringePreparedJustBeforeRinsing (list)
result.fields.syringePreparedJustBeforeRinsing = {
  p1p2p3b1b2: tools.cfg.list(
    fields.syringePreparedJustBeforeRinsing,
    `La seringue est préparée immédiatement avant son utilisation`,
    go.fields.yesNo, {
      sel: result.select.no(result.fields.readyPreFilledSyringe.p1p2p3b1b2.field)
    }
  )
}

// +++ ADD       rinsingBySuccessivePushes (list)
result.fields.rinsingBySuccessivePushes = {
  p1p2p3b1b2: tools.cfg.list(
    fields.rinsingBySuccessivePushes, `Le rinçage est réalisé par poussées successives`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1p2p3b1b2, result.select.withRinsing
      )
    }
  )
}

// +++ ADD       rinsingSuccessivePushesCount (numeric)
result.fields.rinsingSuccessivePushesCount = {
  p1p2p3b1b2: tools.cfg.numeric(
    fields.rinsingSuccessivePushesCount, `Combien de poussées réalisées ?`, 2, {
      un: 'poussée·s',
      sel: tools.allTrue(
        result.select.p1p2p3b1b2,
        result.select.withRinsing,
        result.select.yes(result.fields.rinsingBySuccessivePushes.p1p2p3b1b2.field)
      )
    }
  )
}

// +++ ADD       syringeEliminatedImmediatelyAfterRinsing (list)
result.fields.syringeEliminatedImmediatelyAfterRinsing = {
  p1p2p3b1b2: tools.cfg.list(
    fields.syringeEliminatedImmediatelyAfterRinsing,
    `La seringue (pré-remplie ou non) est éliminée immédiatement après utilisation`,
    go.fields.yesNo, {
      sel: tools.allTrue(result.select.p1p2p3b1b2, result.select.withRinsing)
    }
  )
}

// +++ ADD       solutionContainerEliminatedImmediatelyAfterRinsing (list)
result.fields.solutionContainerEliminatedImmediatelyAfterRinsing = {
  p1p2p3b1b2: tools.cfg.list(
    fields.solutionContainerEliminatedImmediatelyAfterRinsing,
    `L'ampoule/la poche est éliminée immédiatement après utilisation`,
    go.fields.yesNo, {
      sel: tools.allTrue(
        result.select.p1p2p3b1b2,
        result.select.withRinsing,
        result.select.no(result.fields.readyPreFilledSyringe.p1p2p3b1b2.field)
      )
    }
  )
}

// +++ ADD       whyNotSurgicalHandrubbing (list)
// +++ ADD       whyNotSurgicalHandrubbingDetail (text)
result.fields.whyNotSurgicalHandrubbing = {
  p1: result.build.why(
    '', fields.whyNotSurgicalHandrubbing,
    `Pourquoi l'opérateur ne réalise pas de désinfection chirurgicale des mains par friction ?`,
    tools.allTrue(
      result.select.p1,
      tools.oneTrue(
        result.select.no(result.fields.handHygieneBeforeInsertionGloves.p1[0].field),
        tools.different(
          result.fields.handHygieneBeforeInsertionGloves.p1[1].field, 3
        )
      )
    ),
    go.fields.whyNotHHC
  )
}

//     UPDATE    whyNotP2HH (list)               whyNotP2HH>config>values: different sizes
result.fields.whyNotHH.p2[0].config.values = go.fields.whyNotHH

//     UPDATE    whyNotP2HH (list)      whyNotP2HH>contextualize: different values (undefined / function (...)
result.fields.whyNotHH.p2[0].contextualize = (function () {
  const select = result.select
  const ctx = function (sheet) {
    assert(select.p2(sheet, sheet), `Invalid context for field «${this.config.title}»`)
    const noGloves = select.no(fields.handHygieneBeforePeriInsertion)(sheet, sheet)
    return {
      values: noGloves ? go.fields.whyNotP2HH : go.fields.whyNotHH
    }
  }
  Object.defineProperty(
    ctx, 'name', {
      value: `whyNotHH.p2`
    }
  )
  return ctx
})()

//     UPDATE    whyNotP2HH (list)      whyNotP2HH>selectList>0/0: different function names "allTrue ((obsManagment === 2), (handHygieneBeforePeriInsertion === 2))" "allTrue ((obsManagment === 2), oneTrue ((glovesPutOn === 1 || glovesPutOn === 2), (handHygieneBeforePeriInsertion === 2)))}"
result.fields.whyNotHH.p2[0] = tools.select(
  result.fields.whyNotHH.p2[0],
  tools.allTrue(
    result.select.p2,
    tools.oneTrue(
      tools.equals2(result.fields.glovesPutOn.p2p3.field, 1, 2),
      result.select.no(result.fields.handHygieneBeforePeriInsertion.p2p4[0].field)
    )
  )
)

// +++ ADD       whyNotRinsingDoneAfterCatheterInsertion (list)
// +++ ADD       whyNotRinsingDoneAfterCatheterInsertionDetail (text)
result.fields.whyNotRinsingDoneAfterCatheterInsertion = {
  p1p3: result.build.why(
    '', fields.whyNotRinsingDoneAfterCatheterInsertion,
    `Pourquoi le rinçage n'a-t-il pas été réalisé juste après l'insertion du cathéter ?`,
    tools.oneTrue(
      tools.allTrue(
        result.select.p1,
        result.select.no(result.fields.rinsingAfterCatheterInsertion.p1p2.field)
      ),
      tools.allTrue(
        result.select.p3,
        result.select.no(result.fields.rinsingAfterCatheterInsertion.p3.field)
      )
    ),
    go.fields2025.whyNotRinsingDone,
    5
  )
}

//     UPDATE    whyNotSterileGloves (list)whyNotSterileGloves>config>values: different sizes
result.fields.whyNotSterileGloves.b2[0].config.values = go.fields.whyNotSterileGloves

// +++ ADD       whyNotRinsingDoneWhenManipulating (list)
// +++ ADD       whyNotRinsingDoneWhenManipulatingDetail (text)
result.fields.whyNotRinsingDoneWhenManipulating = {
  b1b2: result.build.why(
    '', fields.whyNotRinsingDoneWhenManipulating,
    `Pourquoi le rinçage n'a-t-il pas été réalisé au moment de la manipulation ?`,
    (function () {
      const getManipTypeField = (prefix) => result.fields.manipType[prefix].field
      const deviceUsageField = result.fields.deviceUsage.b1b2.field
      const rinsingBeforeManipulationField = result.fields.rinsingBeforeManipulation.b1b2.field
      const rinsingAfterManipulationField = result.fields.rinsingAfterManipulation.b1b2.field
      const select = result.select

      const selector = (d, s) => {
        const b1 = select.b1(d, s)
        const b2 = select.b2(d, s)
        if (!(b1 || b2)) {
          return false
        }

        const prefix = b1 ? 'b1' : 'b2'
        const manipType = d[getManipTypeField(prefix)]
        if (manipType == null) {
          return false
        }

        const deviceUsage = d[deviceUsageField]
        if (select.no(rinsingBeforeManipulationField)(d, s) &&
            ((deviceUsage === 2 &&
              (manipType === 1 || manipType === 3 || manipType === 4)) ||
             (b2 && manipType === 7))) {
          return true
        }

        return select.no(rinsingAfterManipulationField)(d, s) &&
          (manipType === 2 ||
           ((manipType === 3 || manipType === 4) &&
            (b2 || deviceUsage != null)))
      }

      Object.defineProperty(
        selector, 'name', {
          value: `whyNotRinsingDoneWhenManipulating : (obsManagment === 4 || obsManagment === 5) ${getManipTypeField('b2')} ${getManipTypeField('b1')} ${deviceUsageField} ${rinsingBeforeManipulationField} ${rinsingAfterManipulationField}`
        }
      )
      return selector
    })(),
    go.fields2025.whyNotRinsingDone,
    5
  )
}

result.titles.ultrasound = {
  p1p2: result.build.titleFrom(
    result.titles.ultrasound.p1,
    result.fields.withUltrasound.p1p2,
    result.select.p1p2
  )
}

result.titles.manipulation.b1b2.text = `DÉSINFECTION DE LA CONNECTIQUE AVANT LA MANIPULATION`
result.titles.insertionSite.p3.text = `PRÉPARATION CUTANÉE DU SITE D'INSERTION (ANTISEPSIE)`

result.titles.rinsing = {
  p1p2: result.build.title(
    `RINÇAGE DU CATHÉTER AVEC UNE SERINGUE APRÈS L'INSERTION DU CATHÉTER`,
    result.fields.rinsingAfterCatheterInsertion.p1p2,
    false,
    result.select.p1p2
  ),

  p3: result.build.title(
    `RINÇAGE DE L'AIGUILLE AVEC UNE SERINGUE IMMÉDIATEMENT APRÈS LA POSE`,
    result.fields.rinsingAfterCatheterInsertion.p3,
    false,
    result.select.p3
  ),

  b1b2: result.build.title(
    `RINÇAGE DE LA LIGNE AVEC UNE SERINGUE`,
    result.fields.rinsingBeforeManipulation.b1b2,
    false,
    tools.oneTrue(
      tools.notNull(result.fields.manipType.b1.field),
      tools.notNull(result.fields.manipType.b2.field)
    )
  )
}

result.sheet = {
  titles: [
    result.titles.audited.all,
    result.titles.patient.p1p2p3b2r1,
    result.titles.patient.p4,
    result.titles.ultrasound.p1p2,
    result.titles.padRemoval.r1,
    result.titles.insertionSite.p1p2,
    result.titles.insertionSite.p4,
    result.titles.manipulation.b1b2,
    result.titles.changePad.r1,
    result.titles.insertionSite.p3,
    result.titles.glovesAndHH.p1p2p3b2,
    result.titles.insertion.p4,
    result.titles.newPad.r1,
    result.titles.insertionWithUltrasound.p1,
    result.titles.rinsing.p1p2,
    result.titles.rinsing.p3,
    result.titles.rinsing.b1b2,
    result.titles.probeHandling.p1,
    result.titles.interview.all
  ],

  fields: [
    result.fields.obsManagment.all,
    ...tools.addSelect(result.select.obs, [
      patient.sheetNumber.v2,
      result.fields.obsDate.all
    ]),
    result.fields.isEhpad.p4,
    ...tools.addSelect(result.select.obs, [
      tools.opts(patient.unitType.v2.rw, { sp: 'unitType_v2' }),
      patient.uf
    ]),

    result.fields.place.p1,
    result.fields.otherPlace.p1,
    result.fields.catheterType.p1,
    result.fields.catheterType.p2,
    result.fields.catheterType.p4,
    result.fields.catheterType.b1,
    result.fields.catheterType.b2,
    result.fields.catheterType.r1,
    result.fields.otherCatheterType.p1,
    result.fields.otherCatheterType.b2,
    result.fields.otherCatheterType.r1,

    result.fields.deviceUsage.b1b2,
    result.fields.insertionSite.p1,
    result.fields.insertionSite.r1,
    result.fields.insertionSiteDetail.p1r1,

    result.fields.manipType.b1,
    result.fields.manipType.b2,
    result.fields.otherManipType.b1b2,
    result.fields.isolatedRinsingReason.b1b2,
    result.fields.isolatedRinsingReasonDetail.b1b2,
    result.fields.audited.p1,
    result.fields.audited.p2b1b2,
    result.fields.audited.p3p4r1,
    result.fields.auditedDetail.p3p4r1,
    result.fields.auditedDetail.p1,
    result.fields.student.all,
    result.fields.auditedCleanOutfit.p2p3p4b1b2,
    result.fields.auditedCleanOutfitOrProt.r1,
    result.fields.sterileGown.p1,
    result.fields.sterileGown.r1,
    result.fields.auditedCap.p1p3r1,
    result.fields.compliantAuditedCap.p1p3r1,
    result.fields.auditedMask.p1p3b2r1,
    result.fields.compliantAuditedMask.p1p3b2r1,
    result.fields.auditedCap.b2,
    result.fields.compliantAuditedCap.b2,
    result.fields.isAdult.p1p2p3r1,
    result.fields.childAge.p1p2p3r1,
    result.fields.patientCleanOutfit.p1p2p3p4b2,
    result.fields.patientMask.p1p3b2r1,
    result.fields.compliantPatientMask.p1p3b2r1,
    result.fields.patientSterileField.p1r1,
    result.fields.patientOtherSide.p3b2r1,
    result.fields.patientCap.p1,
    result.fields.compliantPatientCap.p1,
    result.fields.patientHeadSterileField.p1,
    result.fields.strippingSufficient.r1,
    result.fields.bmi.r1,

    result.fields.withUltrasound.p1p2,
    result.fields.usAuditedSearch.p1p2,
    result.fields.searchGelUsed.p1p2,
    result.fields.vialOpeningDateWritten.p1p2,
    result.fields.vialOpenedSince.p1p2,
    result.fields.searchUltrasoundSheath.p1p2,
    result.fields.sheathRemoval.p1p2,
    ...result.fields.ultrasoundWipingSearch.p1p2,

    result.fields.scheduledDressingRepair.r1,
    result.fields.soiledDressing.r1,
    result.fields.dressingPeelsOff.r1,
    ...result.fields.handHygieneBeforeEquipmentPreparation.r1,
    result.fields.sterilePreparation.r1,
    result.fields.removeDressingByStretching.r1,
    result.fields.signsOfSkinIrritation.r1,

    result.fields.removalGloves.r1,
    result.fields.removalGlovesType.r1,
    result.fields.glovesRemoval.r1,

    ...result.fields.handHygieneBeforeAntisepsis.p4,
    ...result.fields.handHygieneBeforeDisinfection.b1,

    result.fields.hasStabilizer.r1,
    result.fields.changeStabilizer.r1,
    result.fields.changeStabilizerReason.r1,
    ...result.fields.handHygieneBeforeStabilizer.r1,

    result.fields.stabilizerGloves.r1,
    result.fields.stabilizerGlovesType.r1,
    result.fields.secondaryGlovesRemoval.r1,

    ...result.fields.handHygieneBeforeAntisepsis.r1,
    result.fields.repairGloves.r1,
    result.fields.repairGlovesType.r1,

    result.fields.dirtySkin.p1p2p3p4,
    result.fields.insertionSiteCleaned.p1p2p3p4r1,

    result.fields.soap.p1p2p3p4r1,
    result.fields.soapOther.p1p2p3p4r1,
    result.fields.rinsing.r1,
    result.fields.dryingWithSterileCompresses.r1,

    ...result.fields.antiseptic.p1p2p3p4,
    ...result.fields.antiseptic.r1,

    result.fields.useCompresses.r1,
    result.fields.useCompresses.p1p2p3p4,
    result.fields.useCompresses.b1b2,

    result.fields.compressesType.r1,
    result.fields.compressesType.p1p2p3p4,
    result.fields.compressesType.b1b2,

    ...result.fields.antiseptic.b1,
    ...result.fields.antiseptic.b2,

    result.fields.valve.b1b2,
    ...result.fields.valveAntiseptic.b1b2,
    result.fields.antisepticPassages.p4,

    result.fields.dry.p1p2p3p4,
    result.fields.dry.r1,
    result.fields.thirdGlovesRemoval.r1,
    result.fields.preFencedSterileField.p3,

    result.fields.glovesNecessary.b1,
    result.fields.gloves.p1,
    result.fields.gloves.p2p3,
    result.fields.gloves.b1,
    result.fields.gloves.b2,

    result.fields.glovesType.p1,
    result.fields.glovesType.p2p3b1,
    result.fields.glovesType.b2,

    result.fields.glovesPutOn.p1,
    result.fields.glovesPutOn.p2p3,
    result.fields.glovesPutOnManip.b2,
    result.fields.palpation.p2,

    ...result.fields.handHygieneBeforeInsertionGloves.p1,
    ...result.fields.handHygieneBeforePreparation.p2,
    ...result.fields.handHygieneBeforePeriInsertion.p2p4,
    ...result.fields.handHygieneBeforePrepaOrInstall.p3b2,
    ...result.fields.handHygieneBeforeGloves.p3,
    ...result.fields.handHygieneBeforeGloves.b2,
    ...result.fields.handHygieneBeforePuncture.p3,
    ...result.fields.handHygieneBeforeManipNoGloves.b2,

    result.fields.gloves.p4,
    result.fields.glovesType.p4,
    result.fields.holdTissue.p4,

    ...result.fields.handHygieneBeforeImplementation.r1,

    result.fields.implementationGloves.r1,
    result.fields.implementationGlovesType.r1,

    result.fields.insertionUltrasoundSheath.p1p2,
    result.fields.probeCovered.p1p2,
    result.fields.sheathJustBeforeInsertion.p1p2,
    result.fields.insertionGelUsed.p1p2,
    result.fields.gelApplied.p1p2,
    result.fields.probeNeedleContact.p1p2,
    result.fields.auditedTouchProbe.p1p2,
    result.fields.probeTouchedWith.p1p2,
    result.fields.probeTouchedWithDetail.p1p2,

    result.fields.glovesRemoval.p1,
    result.fields.glovesRemoval.p2,

    result.fields.rinsingAfterCatheterInsertion.p1p2,
    result.fields.rinsingAfterCatheterInsertion.p3,
    result.fields.rinsingBeforeManipulation.b1b2,
    result.fields.rinsingAfterManipulation.b1b2,
    result.fields.insertionGlovesKeptForRinsing.p1,
    result.fields.insertionGlovesKeptForRinsing.p3,
    result.fields.syringeCapacity.p1p2p3b1b2,
    result.fields.syringeCapacityOther.p1p2p3b1b2,
    result.fields.injectedRinsingSolution.p1p2p3b1b2,
    result.fields.injectedRinsingSolutionOther.p1p2p3b1b2,
    result.fields.readyPreFilledSyringe.p1p2p3b1b2,
    result.fields.singleDoseRinsingSolution.p1p2p3b1b2,
    result.fields.syringePreparedJustBeforeRinsing.p1p2p3b1b2,
    result.fields.rinsingBySuccessivePushes.p1p2p3b1b2,
    result.fields.rinsingSuccessivePushesCount.p1p2p3b1b2,
    result.fields.syringeEliminatedImmediatelyAfterRinsing.p1p2p3b1b2,
    result.fields.solutionContainerEliminatedImmediatelyAfterRinsing.p1p2p3b1b2,

    result.fields.nakedEyeSheathInspection.p1p2,
    result.fields.tearedSheath.p1p2,
    result.fields.probeInspection.p1p2,
    result.fields.dirtyProbe.p1p2,
    result.fields.probeCleaned.p1p2,
    result.fields.probeCleaningMethod.p1p2,
    result.fields.probeCleaningMethodDetail.p1p2,
    ...result.fields.probeCleaningProduct.p1p2,

    ...result.fields.whySheathNotRemovedAfterSearch.p1,
    ...result.fields.whyNotChlAlc2Percent.p1,
    ...result.fields.whyNotSurgicalHandrubbing.p1,
    ...result.fields.whyNotRemoveGlovesAfterTouch.p1,
    ...result.fields.whyNCAuditedOutfit.p3,
    ...result.fields.whyNotAuditedMask.b2,
    ...result.fields.whyNCPatientOutfit.p3,
    ...result.fields.whyNotAlcool.p2p3p4,
    ...result.fields.whyNotSGForPalpation.p2,
    ...result.fields.whyNotHH.p2,
    ...result.fields.whyNotHH.p4,
    ...result.fields.whyNotHHCompliant.p2,
    ...result.fields.whyNotHHBeforeGloves.p3,
    ...result.fields.whyNotRinsingDoneAfterCatheterInsertion.p1p3,
    ...result.fields.whyNotGloves.p4,
    ...result.fields.whyNotHHM.b1,
    ...result.fields.whyNotCompresses.b1,
    ...result.fields.whyNotSterileCompresses.b1,
    ...result.fields.whyNotDisinfectValve.b1b2,
    ...result.fields.whyNotSterileGloves.b2,
    ...result.fields.whyNotHHM.b2,
    ...result.fields.whyNotGROnStabilizerChange.r1,
    ...result.fields.whyNotHHBeforeAntisepsis.r1,
    ...result.fields.whyNotSGForAntisepsis.r1,
    ...result.fields.whyNotRinsingDoneWhenManipulating.b1b2
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v2.rw.field,
        isAdult: result.fields.isAdult.p1p2p3r1.field,
        childAge: result.fields.childAge.p1p2p3r1.field
      }
    )

    checkDate(
      resultNotes, sheet, '2025', {
        obsDate: result.fields.obsDate.all
      }
    )

    checkB2Gloves(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        whyNotHHM: result.fields.whyNotHHM.b2[0].field,
        gloves: result.fields.gloves.b2.field
      }
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        insertionSite: result.fields.insertionSite.p1.field
      },
      'p1'
    )

    checkDeviceInsertionSite(
      resultNotes, sheet, 7, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.r1.field,
        insertionSite: result.fields.insertionSite.r1.field
      },
      'r1'
    )

    checkProbeTouchedWithGloves(
      resultNotes, sheet, 1, {
        obsManagment: result.fields.obsManagment.all.field,
        probeTouchedWith: result.fields.probeTouchedWith.p1p2.field
      },
      result.fields.glovesRemoval.p1
    )

    checkProbeTouchedWithGloves(
      resultNotes, sheet, 2, {
        obsManagment: result.fields.obsManagment.all.field,
        probeTouchedWith: result.fields.probeTouchedWith.p1p2.field
      },
      result.fields.glovesRemoval.p2
    )

    checkBMI(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field
      }
    )

    checkP1Chlorex(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        catheterType: result.fields.catheterType.p1.field,
        whyNotChlAlc2Percent: result.fields.whyNotChlAlc2Percent.p1[0].field
      }
    )

    checkHeadFaceSterileField(
      resultNotes, sheet, {
        patientHeadSterileField: result.fields.patientHeadSterileField.p1.field,
        patientSterileField: result.fields.patientSterileField.p1r1.field
      }
    )

    checkEhpadService(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        isEhpad: result.fields.isEhpad.p4.field,
        unitType: patient.unitType.v2.rw.field
      }
    )

    checkIsolatedRinsingOfContinuousCatheter(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        isolatedRinsingReason: result.fields.isolatedRinsingReason.b1b2.field,
        deviceUsage: result.fields.deviceUsage.b1b2.field
      }
    )

    checkGelAppliedWithoutSheath(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        gelApplied: result.fields.gelApplied.p1p2.field,
        insertionUltrasoundSheath: result.fields.insertionUltrasoundSheath.p1p2.field
      }
    )

    checkVialOpenedSince(
      resultNotes, sheet, {
        vialOpenedSince: result.fields.vialOpenedSince.p1p2.field,
        vialOpeningDateWritten: result.fields.vialOpeningDateWritten.p1p2.field

      }
    )

    checkGelUsed(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        searchGelUsed: result.fields.searchGelUsed.p1p2.field,
        insertionGelUsed: result.fields.insertionGelUsed.p1p2.field
      }
    )

    checkRinsingSuccessivePushesCount(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field
      }
    )

    checkNeedleWithdrawalManipType(
      resultNotes, sheet, {
        obsManagment: result.fields.obsManagment.all.field,
        manipType: result.fields.manipType.b2.field,
        catheterType: result.fields.catheterType.b2.field
      }
    )

    return resultNotes
  }
}

result.assertAllFieldsAreUsed('2025')
export default ice.freeze(result, 10)
